import React, { useCallback, useRef, useState } from "react";
import { Grid } from "@mui/material";
import { useTeams } from "../../../../reactQuery/teams";
import { getAPIBaseUrl } from "../../../../utils/constants";
import useMutate from "../../../../hooks/useMutate";
import { updateImage } from "../../../../services/apiUploadImage";
import { UserAvatar } from "./UserAvatar";
import { UserFormFields } from "./UserFormFields";
import { useQueryClient } from "@tanstack/react-query";
function UserProfileForm({ profileData, userId }) {
  const { teams } = useTeams();
  const teamsArray = teams?.data?.data?.responseData;
  const fileInputRef = useRef(null);
  const queryClient = useQueryClient();

  const [preview, setPreview] = useState(
    profileData?.user?.user_image && 
    getAPIBaseUrl() + "/" + profileData?.user?.user_image
  );
  const { mutate: mutateProfile } = useMutate(updateImage, ["users"], ()=>{}, ()=>{
    queryClient.invalidateQueries({
      queryKey: ["userProfile", userId],
    });
  });

  const handleFileChange = useCallback((event) => {
    const file = event.target.files[0];
    if (file) {
      const newPreview = URL.createObjectURL(file);
      setPreview(newPreview);
      mutateProfile({ user_id: userId, user_image: file });
    }
  }, [mutateProfile, userId]);

  return (
    <Grid item xs={6.5} pl={8} className="d-flex flex-dir-col user-profile-container">
      <UserAvatar
        preview={preview}
        profileData={profileData}
        fileInputRef={fileInputRef}
        handleFileChange={handleFileChange}
      />
      <UserFormFields teamsArray={teamsArray} />
    </Grid>
  );
}





export default React.memo(UserProfileForm); 